import { getList } from './getList';
import getOne from './getOne';

export type { GetListError } from './getList';

export default {
	getList,
	getOne
};
